import React from 'react'
import { useStation } from 'api'
import { Station as StationT } from 'api/types'
import { useTranslation } from 'react-i18next'

export const formatStation = (station: StationT) =>
  `${station.city}, ${station.name}, ${station.street}, ${station.zipcode}`

interface StationProps {
  stationId?: string
}

export const Station: React.FunctionComponent<StationProps> = ({
  stationId,
}) => {
  const { t } = useTranslation()
  const { data: station } = useStation(
    stationId !== '0' ? stationId : undefined
  )

  if (stationId === '0') {
    return <>{t('components.station.noStation')}</>
  }

  if (station) {
    return <>{formatStation(station)}</>
  }

  return null
}
